import { blobAsBase64 } from "@/common/helpers/blob-as-base64";
import { microsoftGraphAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

// has to be users (not user) because it's the microsoft graph API
// and not our own API
export const USER_PHOTO_RESOURCE = "users" as const;
export const USER_PHOTO_OPERATION = "photo" as const;

export enum UserPhotoSize {
  Size48x48 = "48x48",
  Size64x64 = "64x64",
  Size96x96 = "96x96",
  Size120x120 = "120x120",
  Size240x240 = "240x240",
  Size360x360 = "360x360",
  Size432x432 = "432x432",
  Size504x504 = "504x504",
  Size648x648 = "648x648",
}

interface UseUserPhotoQueryOptions {
  userAzureObjectUuid?: string | null;
  size?: UserPhotoSize;
}

export const useUserPhotoQuery = ({ userAzureObjectUuid, size = UserPhotoSize.Size64x64 }: UseUserPhotoQueryOptions) =>
  useQuery<string | null, AxiosError>({
    queryKey: [USER_PHOTO_RESOURCE, USER_PHOTO_OPERATION, userAzureObjectUuid, size],
    enabled: !!userAzureObjectUuid,
    queryFn: async () => {
      const response = await microsoftGraphAxios.get(
        `v1.0/${USER_PHOTO_RESOURCE}('${userAzureObjectUuid}')/photos/${size}/$value`,
        {
          responseType: "blob",
          validateStatus: (status) => status === 200 || status === 404,
        },
      );

      if (response.status !== 200) {
        return null;
      }

      return blobAsBase64(response.data);
    },
    retry: (failureCount, error) => {
      if (error.response?.status === 404) {
        return false;
      }

      return failureCount < 1;
    },
  });
